

export function removeStorage(name: string) {
    try {
        localStorage.removeItem(name);
        localStorage.removeItem(name + '_expiresIn');
    } catch(e) {
        console.log('removeStorage: Error removing key [' + name + '] from localStorage: ' + JSON.stringify(e) );
        return false;
    }
    return true;
}

export function getStorage(key: string) {
    let now = Date.now();
    let expiresInStr = localStorage.getItem(key + '_expiresIn');
    let expiresIn;
    if (expiresInStr === undefined || expiresInStr === null) {
        expiresIn = 0;
    } else {
        expiresIn = Number(expiresInStr);
    }

    if (expiresIn < now) {
        // Expired
        removeStorage(key);
        return null;
    } else {
        try {
            var value = localStorage.getItem(key);
            return value;
        } catch(e) {
            console.log('getStorage: Error reading key ['+ key + '] from localStorage: ' + JSON.stringify(e) );
            return null;
        }
    }
}

export function setStorage(key: string, value: string, expires?: number) {
    if (expires === undefined || expires === null) {
        expires = (31 * 24 * 60 * 60);
    } else {
        expires = Math.abs(expires);
    }

    var now = Date.now();
    var schedule = now + expires * 1000; 
    try {
        localStorage.setItem(key, value);
        localStorage.setItem(key + '_expiresIn', String(schedule));
    } catch(e) {
        console.log('setStorage: Error setting key ['+ key + '] in localStorage: ' + JSON.stringify(e) );
        return false;
    }
    return true;
}
